import React from "react";
import MuiButton from "@mui/material/Button";
import { ButtonProps } from "@mui/material/Button/Button";

import { CustomButton, useStyles, useStylesDefault } from "./styles";

interface Props {
  gradient?: boolean;
  target?: string | undefined;
  rel?: string | undefined;
  href?: string | undefined;
  type?: string | undefined;
}

const Button = (props: Props & Omit<ButtonProps, keyof Props>) => {
  const { gradient = false, startIcon, ...other } = props;
  const classes = useStyles();
  const classesDefault = useStylesDefault();

  const modifiedStartIcon = startIcon && process.env.REACT_APP_BRAND === 'pmaff'
    ? React.cloneElement(startIcon as React.ReactElement, {
        style: {
          color: '#292621',
          ...(startIcon as React.ReactElement).props?.style
        }
      })
    : startIcon;

  return  (
    <>
      {gradient
        //@ts-ignore
        ? <CustomButton className={`${other.className}`} startIcon={modifiedStartIcon} {...other}>
            <span
              className={classes.text}
              {...(
                process.env.REACT_APP_BRAND === 'pmaff' ||
                process.env.REACT_APP_BRAND === 'pmvip' ||
                process.env.REACT_APP_BRAND === 'vph'
                ? {
                style: {
                  color: '#292621'
                }
              } : {})}
            >
              {other.children}
            </span>
          </CustomButton>
        //@ts-ignore
        : <MuiButton className={classesDefault.root} startIcon={modifiedStartIcon} {...other} />
      }
    </>
  );
};

export default Button;
